export default __webpack_public_path__ + "static/media/voucher.0c950c75.svg";